import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { getRadius, isCircular } from '../../../utils/coordinate';
import { angleWithQuadrant } from '../../../utils/vector';
import { pointOfArc } from './default';
import { inferOutsideCircularStyle } from './outside';
/**
 * Surround label transform is used to make labels surround circular.
 */
export function surround(position, points, value, coordinate) {
  if (!isCircular(coordinate)) return {};
  var connectorLength = value.connectorLength,
    connectorLength2 = value.connectorLength2,
    connectorDistance = value.connectorDistance;
  var style = __rest(inferOutsideCircularStyle('outside', points, value, coordinate), []);
  var x0 = style.x0,
    y0 = style.y0;
  var center = coordinate.getCenter();
  var radius = getRadius(coordinate);
  var radius1 = radius + connectorLength;
  var angle = angleWithQuadrant([x0 - center[0], y0 - center[1]]);
  var sign = Math.sin(angle) > 0 ? 1 : -1;
  var _pointOfArc = pointOfArc(center, angle, radius1),
    _pointOfArc2 = _slicedToArray(_pointOfArc, 2),
    newX = _pointOfArc2[0],
    newY = _pointOfArc2[1];
  style.x = newX + (connectorLength2 + connectorDistance) * sign;
  style.y = newY;
  return style;
}